
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule, ApexLegend } from 'ng-apexcharts';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-followup-chart',
  standalone: true,
  imports: [CommonModule, NgApexchartsModule, FormsModule, TooltipModule, BsDatepickerModule],
  templateUrl: './followup-chart.component.html',
  styleUrls: ['./followup-chart.component.scss']
})
export class FollowupChartComponent implements OnChanges {
  // Inputs and outputs
  @Input() visibleBarMonth: boolean = false;
  @Input() bsConfig: any;
  @Input() horizontalBarStartMonth: any;
  @Input() horizontalBarEndMonth: any;
  @Output() horizontalBarStartMonthChange = new EventEmitter<any>();
  @Output() horizontalBarEndMonthChange = new EventEmitter<any>();
  @Input() loading: boolean = false;
  @Input() zeroFollowup: any;
  @Input() totalEnquiries: any;
  @Input() selectedFollowupCardIndex: number = 0;
  @Input() bucketUrl!: string;
  @Input() stageCounts: any = {};

  @Input() horizontalBarOptions: any = {};
  // @Input() horizontalBarOptions: any = {
  //   series: [
  //     {
  //       name: 'Follow Up Count',
  //       data: [79, 12, 0, 0, 0, 0, 0, 0]
  //     }
  //   ],
  //   xaxis: {
  //     categories: ['0', '1', '2', '3', '4', '5', '6', '7']
  //   },
  //   // yaxis: {
  //   //   categories: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']
  //   // }
  // };

  @Input() legend: ApexLegend = { show: false };
  @Output() compare = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
  @Input() preventTyping: ((e: any) => void) | undefined = (e: any) => e.preventDefault();

  // ✅ Default horizontal bar configuration  (kept as-is, but ensures dummy data works)
  private readonly defaultOptions: any = {
    chart: {
      type: 'bar',
      height: 430,
      events: {},
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        columnWidth: '40%',
        horizontal: true,
        distributed: true,
        dataLabels: { position: 'top' }
      }
    },
    dataLabels: {
      enabled: true,
      offsetX: 28,
      style: { fontSize: '12px', fontWeight: 'bold', colors: ['#DCEFFA'] },
      background: {
        enabled: true,
        foreColor: '#007bff',
        borderRadius: 3,
        padding: 7,
        opacity: 0.9,
        borderWidth: 1,
        borderColor: '#e7f3ff'
      }
    },
    colors: [
      '#AE83E8', '#E67FE6', '#8AE9E9', '#E9EB72', '#E78F92',
      '#E6B76B', '#A0DA8C', '#E983A6', '#6BAAE6', '#A783E6', '#E6A083'
    ],
    stroke: { show: true, width: 1, colors: ['#fff'] },
    xaxis: {
      categories: [],
      max: (max: number) => Math.ceil(max * 1.1),
      min: 0
    },
    yaxis: {
      labels: {
        formatter: (val: number) => Math.round(val).toString()
      },
      max: (max: number) => Math.ceil(max * 1.1),
      min: 0
    },
    legend: { show: true }
  };
  ngOnInit(): void {
    console.log('Prevent typing function:', this.defaultOptions.legend);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['horizontalBarOptions']) {
      this.applyDefaultsToOptions();
    }

  }

  private applyDefaultsToOptions() {
    if (!this.horizontalBarOptions) {
      this.horizontalBarOptions = { series: [] };
    }

    // Merge defaults with provided options (non-destructive)
    this.horizontalBarOptions.chart = { ...this.defaultOptions.chart, ...(this.horizontalBarOptions.chart || {}) };
    this.horizontalBarOptions.plotOptions = { ...this.defaultOptions.plotOptions, ...(this.horizontalBarOptions.plotOptions || {}) };
    this.horizontalBarOptions.plotOptions.bar = {
      ...this.defaultOptions.plotOptions.bar,
      ...(this.horizontalBarOptions.plotOptions?.bar || {})
    };
    this.horizontalBarOptions.dataLabels = { ...this.defaultOptions.dataLabels, ...(this.horizontalBarOptions.dataLabels || {}) };
    this.horizontalBarOptions.colors = this.horizontalBarOptions.colors?.length ? this.horizontalBarOptions.colors : this.defaultOptions.colors;
    this.horizontalBarOptions.stroke = { ...this.defaultOptions.stroke, ...(this.horizontalBarOptions.stroke || {}) };
    this.horizontalBarOptions.xaxis = { ...this.defaultOptions.xaxis, ...(this.horizontalBarOptions.xaxis || {}) };
    this.horizontalBarOptions.yaxis = { ...this.defaultOptions.yaxis, ...(this.horizontalBarOptions.yaxis || {}) };
    this.horizontalBarOptions.legend = { ...this.defaultOptions.legend, ...(this.horizontalBarOptions.legend || {}) };
    this.horizontalBarOptions.grid = { ...this.defaultOptions.grid, ...(this.horizontalBarOptions.grid || {}) };
    this.horizontalBarOptions.tooltip = { ...this.defaultOptions.tooltip, ...(this.horizontalBarOptions.tooltip || {}) };
  }

  hasChartData() {
    return this.horizontalBarOptions &&
      Array.isArray(this.horizontalBarOptions.series) &&
      this.horizontalBarOptions.series.length > 0 &&
      this.horizontalBarOptions.series.some((s: any) => s.data && s.data.length > 0);
  }

  onStartBsValueChange(e: any) {
    this.horizontalBarStartMonthChange.emit(e);
  }

  onEndBsValueChange(e: any) {
    this.horizontalBarEndMonthChange.emit(e);
  }
  onCompareBarChart(): void {
    this.compare.emit();
  }

  onClearBarChart(): void {
    this.clear.emit();
  }

}
